import type { LinkClickEvent } from '@atlassian/jira-issue-create-common-types';

/**
 * Link click handler that can be passed to @atlaskit/renderer to open
 * all links in a new tab. Otherwise the default behaviour is to open
 * in the current tab - navigating away from the product.
 */
export const openInNewTabLinkClickEventHandler: LinkClickEvent = (event) => {
	const eventTarget = event.target;
	if (eventTarget instanceof HTMLAnchorElement) {
		eventTarget.target = '_blank';
	}
};
